import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgTargetFilled = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M19.017 9.065a.29.29 0 0 0-.469-.073l-2.242 2.243a.33.33 0 0 0-.039.4 2.5 2.5 0 0 1-2.148 3.781h-3.026a2.5 2.5 0 0 1-1.748-.713l-.002-.002-.002-.002H9.34l-.003-.003-.023-.025-.003-.002-.003-.002a2.5 2.5 0 0 1-.714-1.751v-3.03a2.5 2.5 0 0 1 3.78-2.148.33.33 0 0 0 .4-.04l2.246-2.248a.29.29 0 0 0-.074-.468 8.7 8.7 0 0 0-5.667-.676c-4.723 1.027-7.73 5.703-6.701 10.423 1.027 4.719 5.704 7.723 10.427 6.695 4.72-1.027 7.725-5.703 6.698-10.422a8.5 8.5 0 0 0-.685-1.937"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M20.877 4.605h-1.48v-1.48a.75.75 0 1 0-1.5 0V4.92a.3.3 0 0 1-.087.212l-5.967 5.972V9.885a.75.75 0 0 0-1.5 0v3.031q0 .155.057.29l.001.002h.001q.05.12.143.22v.001q.018.018.035.034a.75.75 0 0 0 .513.203h3.027a.75.75 0 0 0 0-1.5h-1.218l5.968-5.973a.3.3 0 0 1 .212-.088h1.795a.75.75 0 0 0 0-1.5"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgTargetFilled);
export default ForwardRef;
